<template>
    <div class="t-b-mini" @click="clickBox">
        <div class="xy-between">
            <span class="font-size16">{{
                typeBoxData.Content || "新题型名称"
            }}</span>
            <div class="icon xy-center jf-start">
                <el-popconfirm title="确定删除？" @confirm="deleteType">
                    <i class="el-icon-delete" slot="reference" @click.stop></i
                ></el-popconfirm>

                <i class="iconfont" style="margin-top: 1px" @click.stop="goBehind"
                    >&#xe6ba;</i
                >
                <i
                    class="iconfont"
                    style="transform: rotate(-180deg); margin-top: -1px"
                    @click.stop="goAhead"
                    >&#xe6ba;
                </i>
            </div>
        </div>
        <div class="xy-center mt-17">
            <span class="no-wrap c-72777F"
                >共{{ typeBoxData.SubjectNum }}题，每题</span
            >
            <el-input v-model.number="typeBoxData.SubScore" class=""></el-input>
            <span class="font-size18">分</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        typeBoxData: {
            type: Object
        }
    },
    data() {
        return {};
    },
    mounted() {
        // if (!this.typeBoxData.SubScore) this.typeBoxData.SubScore = "";
    },
    watch: {
        // "typeBoxData.SubScore"(score) {
        //     if (!score) this.typeBoxData.SubScore = "";
        // },
    },
    methods: {
        deleteType() {
            this.$emit("delete-type", this.typeBoxData.RankNum);
        },
        goBehind() {
            console.log("向后");
            this.$emit("change-pos", [this.typeBoxData, "behind"]);
        },
        goAhead() {
            this.$emit("change-pos", [this.typeBoxData, "ahead"]);
        },
        clickBox(e) {
            this.$emit("click", e)
        }
    }
};
</script>

<style lang="less" scoped>
.t-b-mini {
    width: 230px;
    min-height: 104px;
    background: #f4f5f6;
    box-sizing: border-box;
    padding: 20px 20px 17px;
    margin-bottom: 20px;
    .icon {
        i {
            color: #256cf4;
            font-size: 15px;
            margin-left: 12px;
            cursor: pointer;
        }
    }
    .icon > i:nth-of-type(0) {
        margin-left: 0;
    }
    .el-input::v-deep {
        width: 50px;
        margin: 0 8px;
        border-radius: 2px;
        input {
            height: 28px;
        }
    }
}
</style>
